/**
 * 共通コンポーネントのエクスポート
 */

export { default as Confirm } from "./dialog/Confirm";
export { default as Message } from "./dialog/Message";

// QAダイアログモジュールの個別エクスポート
export { useQaDialog, QaDialog, QaDialogStyles } from "./dialog/qa";

// QAABダイアログモジュールの個別エクスポート
export { useQaabDialog, QaabDialog, QaabDialogStyles } from "./dialog/qaab";

// 車輌検索ダイアログ（qaab と同様に index から個別エクスポート）
export { default as SyaryoDialog, useSyaryoDialog } from "./dialog/syaryo/index.js";
export {
  formToCarSearchCriteria,
  carSearchRowToSyaryoFormPatch,
  patchFromPcarApiCarRow,
  CAR_SEARCH_LIST_COLUMNS,
  buildCarSearchEngineKatashikiPatchValue,
} from "./dialog/syaryo/carSearchFormBridge.js";
export { PCAR_LIST_COLUMNS, parseEbeCMakerCd } from "./dialog/syaryo/pCarApi.js";
/** @deprecated SyaryoDialog に統合。互換のため SyaryoDialog と同一 */
export { default as SyaryoSearchSampleDialog } from "./dialog/syaryo/SyaryoDialog.js";

// モジュール全体もエクスポート（必要に応じて）
export { default as qa } from "./dialog/qa";
export { default as qaab } from "./dialog/qaab";
